import * as React from "react";
import styles from "./FaultListItem.module.scss";
import DriveParameter from "../icons/DriveParameter";
import ElevatorGray from "../icons/ElevatorGray";
import GroupParameter from "../icons/GroupParameter";
import PlaceholderSymbol from "../icons/PlaceholderSymbol";
import { getDomainDisplayName, priorityMap } from "../../utils/utils";

type FaultListItemProps = {
  fault: Api.AnyFault;
  priority: Api.FaultPriority;
  domain: Api.Domain;
  onItemClick: (
    resultType: number,
    code: number,
    domainId: number,
    inElectrification?: number,
    inCategoryDomain?: number
  ) => void;
  selected: boolean;
  indentation?: number;
  hidden?: boolean;
};

const FaultListItem: React.FC<FaultListItemProps> = (props: FaultListItemProps) => {
  const { fault, priority, domain, selected, indentation, hidden } = props;
  const priorityTitle = priority.name;
  const MapIcons = (domainGroupId: number, priorityLevel: number): any => {
    switch (domainGroupId) {
      case 2:
        return <ElevatorGray fill={priorityMap[priorityLevel].color} title={priorityTitle} />;
      case 3:
        return <DriveParameter fill={priorityMap[priorityLevel].color} title={priorityTitle} />;
      case 4:
        return <GroupParameter fill={priorityMap[priorityLevel].color} title={priorityTitle} />;
      case 7:
        return <ElevatorGray fill={priorityMap[priorityLevel].color} title={priorityTitle} />;
      default:
        return <PlaceholderSymbol fill={priorityMap[priorityLevel].color} title={priorityTitle} />;
    }
  };
  const mainClasses = hidden
    ? [styles.FaultItem, styles.hidden]
    : selected
    ? [styles.FaultItem, styles.FaultItemSelected]
    : [styles.FaultItem];
  return (
    <div
      className={mainClasses.join(" ")}
      style={!!indentation ? { paddingLeft: indentation } : undefined}
      onClick={() =>
        props.onItemClick(
          fault.resultType,
          fault.code,
          fault.domain.id,
          fault.inElectrification,
          fault.inCategoryDomain
        )
      }
    >
      <div className={styles.FaultItemSymbolDiv}>
        {MapIcons(domain?.domainGroup.id, priority.enumValue)}
      </div>
      <div className={styles.FaultItemNameMobile}>
        <span className={styles.FaultItemDomain}>
          {getDomainDisplayName(domain) + " (" + domain.enumValue + ")"}
        </span>
        <span>{fault.name}</span>
      </div>
      <div className={styles.FaultItemNameDesktop}>
        {getDomainDisplayName(domain) + " (" + domain.enumValue + ")"}
      </div>
      <div className={styles.FaultItemCodeDiv}>{fault.code}</div>
      <div className={styles.FaultItemNameDesktop}>{fault.name}</div>
    </div>
  );
};

export default FaultListItem;
